import React from "react";
import {Icon, NavLink, theme} from "@reside/ui";

export const BackButton = ({
  to,
  label,
}: {
  to: string;
  label: string;
}): JSX.Element => (
  <NavLink
    style={{
      marginLeft: theme.space[0],
      marginBottom: theme.space[4],
      color: theme.color.primary,
      textDecoration: "underline",
      fontSize: theme.fontSize[3],
      maxWidth: "fit-content",
    }}
    to={to}
  >
    <Icon name="left" color="primary" size={15} /> {label}
  </NavLink>
);
